import { render } from "./PledgePaymentList.vue?vue&type=template&id=5db54656&scoped=true"
import script from "./PledgePaymentList.vue?vue&type=script&lang=js"
export * from "./PledgePaymentList.vue?vue&type=script&lang=js"

import "./PledgePaymentList.vue?vue&type=style&index=0&id=5db54656&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db54656"]])

export default __exports__